<template>
  <div class="test_red">
    <v-row no-gutters class="test_blue fill-height">
      <v-col v-if="$store.getters.isLoading">
        <v-skeleton-loader type="list-item-three-line@10" />
      </v-col>
      <v-col v-for="(category, index) in datas" v-else :key="index" cols="12">
        <section :id="category.id.toString()" class="test_green pa-0 ma-o">
          <v-row align="center" no-gutters class="mb-3">
            <v-col class="mt-10">
              <span
                class="modal-title-bar mb-n1"
                :class="index === 0 ? '' : 'mt-15'"
                v-text="category.name"
              />
              <span
                v-if="category.discount"
                class="ml-3 discount-title"
                :class="index === 0 ? '' : 'mt-15'"
                v-text="
                  '( ' +
                  category.discount +
                  ' % ' +
                  $t('discovery.discount') +
                  ' )'
                "
              />
              <!--              <v-chip-->
              <!--                v-if="category.discount"-->
              <!--                class="mt-3 mb-3"-->
              <!--                color="primary"-->
              <!--                label-->
              <!--                outlined-->
              <!--                v-text="category.discount + ' %'"-->
              <!--              />-->
              <div>
                <span class="cmodal-title" v-text="category.description" />
              </div>
            </v-col>
          </v-row>
        </section>
        <template>
          <v-row>
            <v-col
              v-for="item in category.products"
              :key="item.id"
              cols="12"
              sm="6"
              md="4"
              :class="{ 'px-0': $vuetify.breakpoint.xs }"
            >
              <div :key="item.id" style="background-color: white">
                <v-list-item
                  class="test_blue mx-0 px-2 card-wrapper-main card"
                  :class="{
                    'product-in-cart': findInCart(item.id),
                    'px-0': $vuetify.breakpoint.sm,
                    'card-mh-m': $vuetify.breakpoint.smAndDown,
                    'card-m-h': $vuetify.breakpoint.smAndUp,
                    'card-wrapper-main-mobile': $vuetify.breakpoint.xs,
                  }"
                  @mouseenter="isHovering = true"
                  @mouseleave="isHovering = false"
                  @click="selectProduct(item)"
                >
                  <v-list-item-content
                    style="min-height: 100px"
                    class="d-flex justify-space-between align-stretch dense"
                  >
                    <v-col
                      v-if="findInCart(item.id)"
                      cols="auto"
                      class="test_yellow px-0 mx-0 pr-4"
                    >
                      <span
                        class="modal-qty-details active"
                        v-text="findInCart(item.id).quantity + ' X '"
                      />
                    </v-col>
                    <v-col class="test_yellow px-0 mx-0 pr-2">
                      <v-row align="center" no-gutters justify="start">
                        <v-text-field
                          class="modal-title-details py-1 trunk-1-lines"
                          v-text="item.name"
                        />
                      </v-row>
                      <div
                        v-if="item.description"
                        style="min-height: 40px"
                        class="modal-title-description py-1 trunk-3-lines"
                        v-text="item.description"
                      />
                      <div
                        v-if="!item.description"
                        style="min-height: 40px"
                        class="modal-title-description py-1 trunk-3-lines"
                      />
                      <!-- getPrice variation-->
                      <div
                        class="py-1 mt-3"
                        style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                        "
                      >
                        <span
                          v-if="item.oldPrice"
                          class="modal-price-details old-price pr-3"
                          v-text="$appFormatters.formatMoney(item.oldPrice)"
                        />
                        <span
                          class="modal-price-details active"
                          v-text="getPrice(item)"
                        />
                        <div class="popular-gap" />
                        <v-chip v-if="item.isPopular" color="primary" x-small>
                          Popular
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="4" sm="3" md="4" class="test_pink pa-0 ma-0">
                      <v-row no-gutters align="center" class="fill-height">
                        <v-img
                          v-if="item.images.length > 0"
                          :src="item.images[0].url"
                          style="image-rendering: optimizeSpeed"
                          cover
                          class="product-img"
                          :height="$vuetify.breakpoint.xs ? '80px' : '90%'"
                          :eager="true"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              />
                            </v-row>
                          </template>
                        </v-img>
                      </v-row>
                    </v-col>
                  </v-list-item-content>
                </v-list-item>
                <!--                <v-divider class="ml-2 my-1" />-->
              </div>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
    <v-dialog
      v-if="dialog && !$vuetify.breakpoint.xsOnly"
      v-model="dialog"
      width="550"
      transition="dialog-bottom-transition"
      content-class="dialog-rounded"
      scrollable
    >
      <ModalProductDetails v-model="dialog" :product="productdetails">
        <template v-slot:close>
          <div class="close-wrapper">
            <v-btn small icon @click="closeModal">
              <v-icon color="primary" v-text="'mdi-close'" />
            </v-btn>
          </div>
        </template>
      </ModalProductDetails>
    </v-dialog>
    <BottomSheetModal
      v-if="isModalOpen && $vuetify.breakpoint.xsOnly"
      :is-open="isModalOpen"
      :title="productdetails.name"
      :image-url="imageUrl"
      @close="closeModal"
    >
      <ProductModalDetail
        :product="productdetails"
        :select-variation="selectVariation"
        :select-addons="selectAddons"
        :form="form"
        :is-loading="isLoading"
        @update:select-variation="updateSelectVariation"
        @update:select-addons="updateSelectAddons"
      />

      <template v-if="$store.getters.storeOnline.status" #footer>
        <!-- Sticky Action Button -->
        <div class="footer-container">
          <!-- Quantity Selector -->
          <v-card class="quantity-selector" elevation="2" rounded="lg">
            <div class="quantity-controls">
              <v-btn
                icon
                size="small"
                variant="text"
                :disabled="form.productQty < 2"
                class="quantity-btn"
                :class="{ 'quantity-btn--disabled': form.productQty < 2 }"
                @click="decrement"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>

              <div class="quantity-display">
                <span class="quantity-number">{{ form.productQty }}</span>
              </div>

              <v-btn
                icon
                size="small"
                variant="text"
                class="quantity-btn"
                @click="increment"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </v-card>

          <!-- Add to Cart Button -->
          <v-btn
            :disabled="$store.getters.addonsProductErrors > 0 || isLoading"
            color="primary"
            style="height: 45px; border-radius: 5px"
            elevation="3"
            :loading="isLoading"
            class="add-to-cart-btn"
            @click="addToCart"
          >
            <span>{{ $t("discovery.add_to_order") }}</span>
            <span class="price-amount">{{
              $appFormatters.formatMoney(totalPrice)
            }}</span>
          </v-btn>
        </div>
      </template>
    </BottomSheetModal>
  </div>
</template>

<script>
import ModalProductDetails from "./ModalProductDetails.vue";
import ProductModalDetail from "@/views/front/discovery/components/ProductModalDetail.vue";
import BottomSheetModal from "@/components/common/BottomSheetModal.vue";
export default {
  name: "ProductList",
  components: {
    ProductModalDetail,
    ModalProductDetails,
    BottomSheetModal,
  },
  data: () => ({
    dialog: false,
    isHovering: false,
    productdetails: {},
    isModalOpen: false,
    isLoading: false,
    selectVariation: null,
    selectAddons: [],
    form: new Form({
      storeId: null,
      productQty: 1,
      sessionId: null,
    }),
  }),
  computed: {
    datas: function () {
      return this.$store.getters.storeMenu;
    },
    imageUrl() {
      return this.productdetails.images?.length
        ? this.productdetails.images[0].url
        : null;
    },
    totalPriceAddons: {
      get() {
        let total = 0;
        if (this.selectAddons.length > 0) {
          total = this.selectAddons.reduce(function (total, currentValue) {
            return total + parseFloat(currentValue.subtotal);
          }, 0);
          return total.toFixed(2);
        } else {
          return 0;
        }
      },
      set(val) {
        return val;
      },
    },
    totalPrice: {
      get() {
        let subTotal =
          parseFloat(this.price) + parseFloat(this.totalPriceAddons);
        let total = this.form.productQty * subTotal;
        return total.toFixed(2);
      },
      set(val) {
        return val;
      },
    },
    price: {
      get() {
        return this.selectVariation
          ? this.selectVariation.price
          : parseFloat(this.productdetails.price).toFixed(2);
      },
      set(val) {
        return val;
      },
    },
  },
  watch: {
    dialog: function (value) {
      if (!value) {
        this.productdetails = {};
      }
    },
    "$store.getters.guestSessionId": {
      handler(newVal) {
        this.form.sessionId = newVal ?? null;
      },
      immediate: true,
    },
  },
  created() {
    const self = this;
    self.form.storeId = self.$store.getters.storeInfo.id;
    self.form.sessionId = self.$store.getters.guestSessionId;
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    resetFormData() {
      this.selectVariation = null;
      this.selectAddons = [];
      this.productdetails = {};
      this.form.productQty = 1;
      this.form["shoppingCartDetails"] = [];
      delete this.form["productVariationId"];
      this.$store.dispatch("discovery/set_AddosErrorsInit");
    },
    updateSelectVariation(value) {
      this.selectVariation = value;
    },
    updateSelectAddons(value) {
      this.selectAddons = value;
    },
    increment: function () {
      const self = this;
      self.form.productQty = parseInt(self.form.productQty, 10) + 1;
    },
    decrement: function () {
      const self = this;
      self.form.productQty = parseInt(self.form.productQty, 10) - 1;
    },
    visibilityChanged: function (isVisible) {
      this.isVisible = isVisible;
    },
    addToCart: async function () {
      const self = this;
      self.isLoading = true;
      if (self.selectVariation) {
        self.form["productVariationId"] = self.selectVariation.id;
      } else {
        // Remove productVariationId if no variation is selected
        delete self.form["productVariationId"];
      }
      if (self.selectAddons?.length > 0) {
        self.form["shoppingCartDetails"] = [];
        self.selectAddons.map((item) => {
          self.form.shoppingCartDetails.push({
            productSubAddonPivotId: item.productSubAddonPivotId,
            subAddonQty: item.subAddonQty,
          });
        });
      }
      self.form.productId = self.productdetails.id;
      const { data } = await self.form.post("/app/orders/shopping/cart");
      if (!self.form.sessionId) {
        await self.$store.dispatch("guest/setSessionId", data.data.sessionId);
        self.form.sessionId = data.data.sessionId;
      }
      if (this.$vuetify.breakpoint.mdAndUp) {
        Toast.fire({
          icon: "success",
          title: data.message,
        });
      }
      await this.$store.dispatch("cart/setLoad");
      self.closeModal();

      // self.$store.dispatch("loading/done");
      self.isLoading = false;
      this.$emit("input", false);
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.resetFormData();
      this.isModalOpen = false;
      this.dialog = false;
    },
    handleAction() {
      console.log("Action handled!");
      this.closeModal();
    },
    handleScroll() {
      const sections = document.querySelectorAll("section");
      let current = "";
      let staticHeight = 200;
      if (window.matchMedia("(max-width: 960px)").matches) {
        staticHeight = 50;
      }
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (window.scrollY >= sectionTop - staticHeight) {
          current = section.getAttribute("id");
        }
      });
      if (current && this.$store.getters.selectedTab !== current) {
        const temp = [...(this.$store.getters.storeMenu ?? [])].map(
          (v) => v.id
        );
        const index = temp.findIndex((v) => v === parseInt(current));
        this.$store.dispatch("discovery/setSelectedTab", index);
      }
    },
    selectProduct: function (item) {
      const self = this;
      self.productdetails = item;
      self.isModalOpen = true;
      self.dialog = true;
    },
    findInCart: function (id) {
      const self = this;
      if (self.$store.getters.cartDetails) {
        return _.find(self.$store.getters.cartDetails.items, {
          prodcutId: id,
        });
      } else {
        return false;
      }
    },
    getPrice: function (item) {
      const self = this;
      if (item.productVariation.length > 0) {
        return self.$appFormatters.formatMoney(
          item.productVariation[0].sellingPrice
        );
      } else {
        return self.$appFormatters.formatMoney(item.price);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  gap: 16px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  position: sticky;
  bottom: 0;
  z-index: 10;
}

/* Quantity Selector Styles */
.quantity-selector {
  min-width: 140px;
  padding: 8px 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

@media (max-width: 600px) {
  .quantity-selector {
    padding: 3.6px 12px !important;
  }
}

.quantity-selector:hover {
  elevation: 4;
  border-color: rgba(0, 0, 0, 0.15);
}

.quantity-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.quantity-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  transition: all 0.2s ease;
  color: rgb(var(--v-theme-primary));
}

.quantity-btn:hover:not(.quantity-btn--disabled) {
  background-color: rgba(var(--v-theme-primary), 0.1);
  transform: scale(1.05);
}

.quantity-btn--disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.quantity-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 48px;
  padding: 4px 8px;
}

.quantity-number {
  font-size: 18px;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  line-height: 1;
}

.quantity-label {
  font-size: 11px;
  color: rgb(var(--v-theme-on-surface-variant));
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

/* Add to Cart Button Styles */
.add-to-cart-btn {
  flex: 1;
  font-weight: 600;
  text-transform: none;
  position: relative;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  //padding: 6px 8px;
}

.text-wrap {
  flex: 1;
  min-width: 0;
}

.text-wrap span {
  font-size: clamp(12px, 3vw, 16px); /* Responsive font size */
  line-height: 1.2;
}

.btn-price {
  flex-shrink: 0;
  font-size: clamp(12px, 3vw, 16px);
}

/* Optional: Add some extra refinements */
.btn-price .price-amount {
  font-weight: 600; /* Make price stand out */
}

@media (max-width: 400px) {
  .add-to-cart-btn {
    font-size: 12px !important;
    .price-amount {
      font-size: 12px !important;
    }
  }
}

@media (max-width: 380px) {
  .add-to-cart-btn {
    font-size: 10px !important;
    .price-amount {
      font-size: 10px !important;
    }
  }
}

@media (max-width: 375px) {
  .add-to-cart-btn {
    font-size: 9px !important;
    .price-amount {
      font-size: 9px !important;
    }
  }
}

/* For very small screens, you can add additional adjustments */
@media (max-width: 280px) {
  .text-wrap span {
    font-size: clamp(10px, 4vw, 14px);
  }

  .btn-price {
    font-size: clamp(12px, 4vw, 16px);
  }
}
.min-sm {
  max-width: 100vw;
}

.add-to-cart-btn.v-btn--loading .btn-content {
  opacity: 0.7;
}

/* Responsive Design */
@media (max-width: 600px) {
  .footer-container {
    padding: 12px 8px;
    gap: 12px;
  }

  .quantity-selector {
    min-width: 120px;
  }

  .add-to-cart-btn {
    min-width: 180px;
    height: 48px;
  }

  .btn-text {
    font-size: 14px;
  }

  .price-amount {
    font-size: 14px;
    font-weight: 700 !important;
    margin-left: 4px;
  }
}

/* Animation for quantity changes */
.quantity-number {
  transition: all 0.2s ease;
}

.quantity-display:active .quantity-number {
  transform: scale(1.1);
}

/* Accessibility improvements */
.quantity-btn:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.add-to-cart-btn:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}
.close-wrapper {
  display: flex;
  background-color: white;
  justify-content: flex-end;
  padding: 2px;
  border-radius: 50%;
}
.card {
  /* your card styles here */
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: scaleY(1.1);
}
.card-wrapper-main {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
  border-radius: 10px;
}
.card-wrapper-main-mobile {
  box-shadow: unset !important;
  border-radius: unset;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.product-in-cart {
  border-left: solid;
  border-color: var(--v-primary-base);
  border-radius: 5px;
}
.product-img {
  border-radius: 10px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}
.card-mh-m {
  max-height: 120px !important;
  min-height: 120px !important;
}
.card-m-h {
  min-height: 140px !important;
  max-height: 140px !important;
}
.trunk-3-lines {
  max-height: 2.4em;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.trunk-1-lines {
  max-height: 2.4em;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.v-list-item__content {
  min-height: 100px;
}
.product-wrapper {
  display: flex !important;
  flex-direction: row !important;
  gap: 30px;
  flex-wrap: wrap !important;
  justify-content: center !important;
}
.product-box {
  width: 100% !important;
  max-width: 100%;
}
.min-sm {
  max-width: 100vw;
}
</style>
